module.exports = __webpack_public_path__ + "assets/logo.3e8e2295.svg";